<template>
  <div class="admin_person_page">
    <div class="fr add_admin_person" @click="addAdminPerson">创建管理员</div>
    <table class="table mt20">
      <tr>
        <th v-for="tableTittle in tableTittles">{{tableTittle}}</th>
      </tr>
      <template v-for="(value,index) in personData">
        <tr>
          <td>{{value.role==1?'高级管理员':'普通管理员'}}</td>
          <td>{{value.username}}</td>
          <td>{{value.mobile}}</td>
          <td>{{value.company_name}}</td>
          <td>
            <span v-if="value.role!=1" style="cursor: pointer;" @click="delAdmin(index)">删除</span>
          </td>
        </tr>
      </template>


    </table>
    <loading v-show="loading"></loading>
    <Pagination :total="listcount" :pagesize="pagesize" :pagegroup="pagegroup" @pagechange="pagechange"></Pagination>
    <msgTips v-show="showFlag" @confirm="createAdmin" @cancel="closeLayer" mheight="300" title="创建管理员" :show-button="showButton">
      <div class="fill_group_row clearfix  w_half">
        <div class="form_group clearfix">
          <label class="control_label h-l15"><em>*</em>姓名</label>
          <div class="form_control w_auto ">
            <input class="i_w260 form_input"  type="text" v-model="createAdminParams.name">
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label h-l15"><em>*</em>手机号</label>
          <div class="form_control w_auto ">
            <input class="i_w260 form_input" type="text" v-model="createAdminParams.mobile"/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label h-l15">居民身份证</label>
          <div class="form_control w_auto ">
            <input class="i_w260 form_input" type="text" v-model="createAdminParams.id_card"/>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label h-l15"><em>*</em>负责单位</label>
          <div class="form_control " style="width: 343px; margin-left: 130px">
            <template v-if="addCompany">
              <select class="i_w260 form_input" style="padding-top: 0; padding-bottom: 0;" v-model="createAdminParams.company_id">
                <option value="0">请选择单位</option>
                <option v-for="(value,index) in companyList" :value="value.id">{{value.company_name}}</option>
              </select>
              <span class="ml10 add_company" @click="toAddCompany"><i>+</i>创建单位</span>
            </template>
            <template v-else>
              <input class="i_w260 form_input" type="text" v-model="newCompanyName"/>
              <span class="ml10 add_company"><i class="is_add_company" @click="addCompanyFuc">确认</i><i class="is_add_company" @click="cancelAddCompany">取消</i></span>
            </template>
          </div>
        </div>
      </div>
    </msgTips>
    <msgTips v-show="showDel" @confirm="confirmDel(index)" @cancel="layerCancel" title="提示">
      <p class="layer_content">确定删除该管理员？</p>
    </msgTips>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>

</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import msgTips from '../../components/layer/msgTips'
  import Pagination from '../../libs/pagination'
  import toastTips from '../../components/layer/toastTips'
  export default{
    name:'adminList',
    components:{
      msgTips,
      Pagination,
      toastTips
    },
    data () {
      return {
        tableTittles:['管理员','姓名','手机号','负责单位','操作'],
        showFlag:false,
        addCompany:true,
        personData:[],
        loading:true,
        pagesize:15,
        pagegroup:7,
        pageNo:1,
        listcount:0,
        showDel:false,
        index:null,
        toast:false,
        toastContent:'',
        showButton:true,
        createAdminParams:{
          name:'',
          mobile:'',
          id_card:'',
          company_id:0
        },
        newCompanyName:'',
        companyList:[]
      }
    },
    mounted:function(){
      this.getAdminList();
      this.getCompanyList();
    },
    methods:{
      pagechange:function(currentpage){
        this.pageNo=currentpage;
        this.getAdminList();
      },
      getAdminList () {
        var that=this;
        axios.get('/admin/list',{
          page:that.pageNo,
          limit:that.pagesize
        }).then((response)=>{
          if(response.data.code==22000){
            that.loading=false;
            that.listcount=response.data.result.count;
            that.personData=response.data.result.list
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        });
      },
      getCompanyList () {
        var that=this;
        axios.get('/admin/company/list',{

        }).then((response)=>{
          if(response.data.code==22000){
            this.companyList=response.data.result.list
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      delAdmin (index) {
        this.index=index;
        this.showDel=true;
      },
      createAdmin(){
        var that=this;
        axios.post('/admin/addAdmin',qs.stringify(
          this.createAdminParams
        )).then((response)=>{
          if(response.data.code==22000){
            that.closeLayer();
            that.toast=true;
            that.toastContent='添加成功';
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
              window.location.reload();
            },3000)
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }

        })
      },
      addCompanyFuc(){
        var that=this;
        if(!this.newCompanyName){
          that.toast=true;
          that.toastContent='请填写信息';
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000);
          return false;
        }
        axios.post('/admin/company/add',qs.stringify(
          {
            company_name:this.newCompanyName
          }
          )).then((response)=>{
            if(response.data.code==22000){
                this.createAdminParams.company_id=response.data.result.id;
                this.getCompanyList();
                this.cancelAddCompany();
                that.toast=true;
                that.toastContent='添加成功';
                setTimeout(function(){
                  that.toast=false;
                  that.toastContent='';
                },3000)

            }else if(response.data.code==50001){
              window.location.href='/#/login'
            }else{
              that.toast=true;
              that.toastContent=response.data.message;
              setTimeout(function(){
                that.toast=false;
                that.toastContent='';
              },3000)
            }
        })
      },
      confirmDel(index){
        var that=this;
        axios.post('/admin/delAdmin',qs.stringify(
          {id:this.personData[index].id}
        )).then((response)=>{
          if(response.data.code==22000){
            for(var i =0 ; i<this.personData.length; i++){
              if(i==index){
                this.personData.splice(i,1)
              }
            }
            that.layerCancel();
            that.toast=true;
            that.toastContent='删除成功';
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        });
      },
      addAdminPerson () {
        this.showFlag=true;
      },
      closeLayer () {
        this.showFlag=false;
      },
      layerCancel:function(){
        this.showDel=false;
      },
      toAddCompany () {
        this.addCompany=false;
        this.showButton=false;
      },
      cancelAddCompany () {
        this.addCompany=true;
        this.showButton=true;
      }
    },
    watch:{

    }
  }
</script>
<style lang="less" scoped>
  .admin_person_page{
    .i_w260{
      width:230px!important;
    }
    .form_group{
      margin-bottom: 10px;
    }
    .form_input{
      height:25px;
    }
    .control_label{
      height: 8px;
      line-height: 8px;
    }
  }
  .add_admin_person{
    position: absolute;
    top:20px;
    right:0;
    cursor: pointer;
  }
  .add_company{
    font-size: 14px;
    color: #489EFE;
    vertical-align:middle;
    cursor:pointer;
    i{
      display: inline-block;
      vertical-align: middle;
      color: #489EFE;
      line-height: 20px;
      font-size: 20px;
    }
    i.is_add_company{
      margin-right: 10px;
      font-size: 14px;
    }
  }
  .h-l15{
    height:15px!important;
    line-height:15px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/power_set/adminList.vue